
import certificate from '../components/certificate/index.vue'
import dispoitStep from '../components/dispoit-step.vue'
import dispointHeader from '../components/dispoint-header.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import  { common, commonApi, check }  from '@/common/index';
import {mapState,mapActions} from 'vuex';
import getPayInfoMX from '../mixins/getPayInfo.js'
import publicMX from '../../mixins/publicMX.js'
import { parseTime } from '@/common/utils/Date.js'
export default {
directives: { TransferDom },
components: { XButton, Group, XInput, Confirm ,dispoitStep,certificate,dispointHeader, Qrcode },
mixins: [getPayInfoMX, publicMX],
filters: {
timeFilter(v) {
return parseTime(v)
}
},
data() {
return {
deposit: { imgUrl: '', amount: '' }
}
},
created() {

},
computed: {
qrCode() {
if (!this.paySelected.qrCode) {
return null
} else {
return this.$store.state.linkList.staticDomain + this.paySelected.qrCode
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/otherTransfer/index.vue